'use client'
import React from 'react'
import { Box } from '@mui/material'
import type { CarBackdropProps, CarBackdropVariant } from '@/types/CarBackdrop'

const CDN_BASE = 'https://cdn.zuto.cloud/assets/images'

const variants: Record<'default' | 'simple', CarBackdropVariant> = {
  default: {
    backdropSrc: `${CDN_BASE}/back-drop-desktop.svg`,
    carSrc: `${CDN_BASE}/vehicles/desktop/Audi-A1.png`,
    carAlt: 'Audi car',
    carWidth: { xs: '40%', sm: '36%', md: '30%' },
    carBottom: '-7%',
    carLeft: '50%'
  },
  simple: {
    backdropSrc: `${CDN_BASE}/simple-backdrop-desktop.svg`,
    carSrc: `${CDN_BASE}/homepage/mobile/audi.png`,
    carAlt: 'Audi car',
    carWidth: { xs: '35%', md: '22%' },
    carBottom: '27%',
    carLeft: '22%'
  }
}

const CarBackdrop = ({ simple = false }: CarBackdropProps) => {
  const { backdropSrc, carSrc, carAlt, carWidth, carBottom, carLeft } = simple
    ? variants.simple
    : variants.default

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        mx: 'auto',
        mb: 8
      }}
    >
      <Box component="img" src={backdropSrc} alt="" sx={{ width: '100%', display: 'block' }} />
      <Box
        component="img"
        src={carSrc}
        alt={carAlt}
        sx={{
          position: 'absolute',
          left: carLeft,
          bottom: carBottom,
          transform: 'translateX(-50%)',
          width: carWidth
        }}
      />
    </Box>
  )
}

export default CarBackdrop
